export default __webpack_public_path__ + "static/media/logo-new.fb712fe7.png";